// src/Screens/admin/Dashboard/DashboardManagement.jsx
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import {
  FiUsers,
  FiShoppingBag,
  FiTrendingUp,
  FiBarChart2,
  FiShoppingCart,
  FiAlertCircle,
} from "react-icons/fi";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import "../../../assets/css/admin/screens/dashboard/AdminDashboardManagement.css";
import AppContext from "../../../contexts/AppContext";
import StackedBarChart from "../../../components/general/barchart/BarChart";

const FALLBACK_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"];

const DashboardManagement = () => {
  const { baseUrl, adminAuthToken } = useContext(AppContext);

  const [isDark] = useState(false);
  const [stats, setStats] = useState(null);

  const viewDashboardStats = () => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const adminId = loggedInAdmin?.id;
    const token = localStorage.getItem("adminAuthToken");

    axios
      .get(`${baseUrl}/admin/dashboard/stats`, {
        headers: { Authorization: `Bearer ${adminAuthToken}` },
        params: { chadmin_id: adminId },
      })
      .then((response) => {
        setStats(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewDashboardStats();
  }, []);

  // ✅ cards array mein ?. use karo, stats ? condition hatao
  const cards = [
    {
      label: "Total Customers",
      value: stats?.total_customers?.toLocaleString() ?? "0",
      sub: "Active in last 30 days",
      icon: <FiUsers />,
      iconClass: "ad-overview-icon",
    },
    {
      label: "Total Shops",
      value: stats?.total_shops?.toLocaleString() ?? "0",
      sub: `${stats?.pending_shops ?? 0} pending approvals`,
      icon: <FiShoppingBag />,
      iconClass: "ad-overview-icon",
    },
    {
      label: "Total Sales",
      value: stats?.total_sales ? (
        <>
          <span className="ad-rs-sign">Rs</span>
          {stats.total_sales.toLocaleString()}
        </>
      ) : (
        "0"
      ),
      sub: "This month",
      icon: <FiTrendingUp />,
      iconClass: "ad-overview-icon",
    },
    {
      label: "Total Orders",
      value: stats?.total_orders?.toLocaleString() ?? "0",
      sub: `${stats?.inprogress_orders?.toLocaleString() ?? 0} in progress`,
      icon: <FiShoppingCart />,
      iconClass: "ad-overview-icon",
    },
    {
      label: "Complaints",
      value: stats?.complaints?.toLocaleString() ?? "0",
      sub: `${stats?.high_priority ?? 0} high-priority`,
      icon: <FiAlertCircle />,
      iconClass: "ad-overview-icon ad-overview-icon-alert",
    },
    {
      label: "Platform Revenue",
      value: stats?.platform_revenue ? (
        <>
          <span className="ad-rs-sign">Rs</span>
          {stats.platform_revenue.toLocaleString()}
        </>
      ) : (
        "0"
      ),
      sub: "Commission earned this month",
      icon: <FiBarChart2 />,
      iconClass: "ad-overview-icon",
    },
  ];

  // ── Revenue Analytics chart data (backend se "revenue_analytics" array expected) ──
  const revenueAnalytics = stats?.revenue_analytics ?? [];
  const hasRevenueData = revenueAnalytics.length > 0;

  const revenueLabels = hasRevenueData
    ? revenueAnalytics.map((d) => d.month)
    : FALLBACK_MONTHS;
  const grossSales = hasRevenueData
    ? revenueAnalytics.map((d) => d.gross_sales ?? 0)
    : FALLBACK_MONTHS.map(() => 0);
  const platformRevenue = hasRevenueData
    ? revenueAnalytics.map((d) => d.platform_revenue ?? 0)
    : FALLBACK_MONTHS.map(() => 0);

  return (
    <AdminMasterLayout>
      <div className={`ad-shell ${isDark ? "dark-mode" : "light-mode"}`}>
        <main className="ad-main">
          <div className="ad-card-shell">
            <h3 className="ad-section-title">Overview</h3>

            <div className="ad-overview">
              {cards.map((card, idx) => (
                <div key={idx} className="ad-overview-card">
                  <div>
                    <span className="ad-overview-label">{card.label}</span>
                    <h3>{card.value}</h3>
                    <p className="ad-muted mb-0">{card.sub}</p>
                  </div>
                  <div className={card.iconClass}>{card.icon}</div>
                </div>
              ))}
            </div>

            {/* Revenue Analytics Chart */}
            <Row className="mt-4">
              <Col xs={12}>
                <div className="ad-card">
                  <h4>Revenue Analytics</h4>
                  <StackedBarChart
                    labels={revenueLabels}
                    datasets={[
                      {
                        label: "Total gross sales",
                        data: grossSales,
                        color: "#378ADD",
                      },
                      {
                        label: "Platform revenue",
                        data: platformRevenue,
                        color: "#eb6834",
                      },
                    ]}
                    isDark={isDark}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </main>
      </div>
    </AdminMasterLayout>
  );
};

export default DashboardManagement;
